import { useState } from "react";
import { Alert, Box } from "@mui/material";
import {
  PTAutocompleteInput,
  PTButton,
  PTForm,
  PTPhoneInput,
  PTTextInput,
  PTTranslate,
  PTTypography,
} from "../../../../common/components/ui";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { createAccountValidationSchema } from "../others/createAccountValidationSchemas";
import { createAccountInitialValues } from "../others/createAccountInitialValues";
import { useInscription } from "../../../../common/hooks";
import { useAuth } from "../../../../common/provider";
import RegleGestionComponent from "../compoenent/RegleGestionComponent ";

const CreateAccountDialog = () => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState(null);
  const { toggleLoginDialog } = useAuth();

  const { mutate: inscription, isPending } = useInscription({
    onSuccess: () => {
      setIsSubmitted(true);
    },
    onError: (errorMessage) => {
      setError(errorMessage);
    },
  });

  const handleSubmit = (values) => {
    const payload = {
      raisonSociale: values?.raisonSociale,
      payId: values?.payId,
      email: values?.email,
      telephone: values?.telephone,
    };

    inscription(payload);
  };
  return (
    <>
      {isSubmitted ? (
        <Box sx={{ mt: 2.1, mb: 2, textAlign: "center" }}>
          <Box sx={{ mb: 2 }}>
            <CheckCircleOutlineIcon color="success" sx={{ fontSize: 64 }} />
          </Box>
          <PTTypography variant="h4" component="h2" gutterBottom>
            registration.successTitle
          </PTTypography>
          <PTTypography variant="body1" color="text.secondary" paragraph>
            registration.successParagraph
          </PTTypography>
        </Box>
      ) : (
        <>
          {error && (
            <Alert severity="error" sx={{ marginBottom: 2.5 }}>
              <PTTranslate tk={`${error}`} />
            </Alert>
          )}
          <PTForm
            name="suscription"
            initialValues={createAccountInitialValues}
            onSubmit={handleSubmit}
            submitButtonText={"registration.button"}
            validationSchema={createAccountValidationSchema}
            retableOn={false}
            fullWidthSubmitButton={true}
            buttonStyle={{
              width: "100%",
              maxWidth: "100%",
              backgroundColor: "#407BFF",
              py: 1,
              border: "none",
              fontSize: "16px",
              "&:hover": {
                backgroundColor: "#407BFF",
              },
              "&:focus": {
                backgroundColor: "#407BFF",
              },
            }}
            isPending={isPending}
          >
            <PTTextInput
              lg={12}
              md={12}
              name="raisonSociale"
              hiddenLabel
              placeHolder={"registration.field1"}
              type="raisonSociale"
            />
            <PTAutocompleteInput
              lg={12}
              md={12}
              name="payId"
              hiddenLabel
              placeHolder={"registration.field2"}
              valueRenderer={(item) => item.id}
              reference={"LISTE_PAYS"}
            />
            <PTTextInput
              lg={12}
              md={12}
              name="email"
              hiddenLabel
              placeHolder={"registration.field3"}
              type="email"
            />
            <PTPhoneInput
              lg={12}
              md={12}
              name="telephone"
              hiddenLabel
              placeHolder={"registration.field4"}
            />
            <RegleGestionComponent />
          </PTForm>
        </>
      )}
      <Box
        sx={{
          mt: 2.1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <PTTypography
          variant="body2"
        >
          registration.accountExists
        </PTTypography>
        <PTButton
          title={"registration.button2"}
          variant="text"
          onClick={toggleLoginDialog}
        />
      </Box>
      </>
  );
};

export default CreateAccountDialog;
